/**
 * Query key for the current session; invalidate it after login/logout.
 *
 * Its own module so the query client (lib/query-client.ts) can name it without
 * importing the auth API, which itself imports the query client to clear it on
 * sign-out.
 */
export const authMeKey = ['auth', 'me'] as const

/** True for the session query's key. */
export function isAuthMeKey(key: readonly unknown[]): boolean {
  return key.length === authMeKey.length && key[0] === authMeKey[0] && key[1] === authMeKey[1]
}
